import { references } from '../../ui/form/components/Application/schemes';
import gettable21 from './gettable2.1';

function getApplicant(objects) {
  const { prep: { data: { surname, name, midname, orgname, orgform } = {}, type } = {} } = objects;
  if(type == 1) {
    return `${name ? name.value : ''}${midname ? (' ' + midname.value) : ''} ${surname ? surname.value : ''}`;
  } else {
    return `${orgform ? orgform.value : ''} ${orgname ? orgname.value : ''}`;
  }
}

function getAdress(objects) {
  const { prep: { data: { adress } = {} } = {} } = objects;
  return adress && adress.value;
}

function getINN(objects) {
  const { prep: { data: { INN } = {}, type } = {} } = objects;
  return INN && INN.value;
}

function getOGRN(objects) {
  const { prep: { data: { OGRN } = {}, type } = {} } = objects;
  return OGRN && OGRN.value;
}

function getObjectName(objects) {
  const { prep: { obj: { name } = {}, type } = {} } = objects;
  return name && name.value;
}

function getObjectCode(objects) {
  const { prep: { obj: { code } = {}, type } = {} } = objects;
  return code && code.value;
}

function getActivity(objects) {
  const { prep: { data: { activityName } = {}, type } = {} } = objects;
  console.warn(activityName);
  return activityName && activityName.value;
}

function getOKVED(objects) {
  const { prep: { data: { activityCode } = {}, type } = {} } = objects;
  console.warn(activityCode);
  return activityCode && activityCode.value;
}

export default function OrderFormProcess(state) {
  return {
    type: "ReadValue",
    subj: "Заявитель",
    objName: ["OrderFormData"],
    form: {
      type: "OrderForm",
      references: references,
      readOnly: false,
      baseYear: state.objects.year,
      datas: state.objects.applicationformdata.value,
      application : {
        "applicant": getApplicant(state.objects),
        "address" : getAdress(state.objects),
        "OGRN" : getOGRN(state.objects),
        "INN" : getINN(state.objects),
        "OKVED" : getOKVED(state.objects),
        "activityName" : getActivity(state.objects),
        "objectName" : getObjectName(state.objects),
        "objectCode" : getObjectCode(state.objects),
        "director" : "",
        "fillingDate" : {"day": 31, "month" : "Июня", "year" : state.objects.year},
        "baseYear" : state.objects.year,
        "sectionIII" : "Расчеты", //не вносится в отчет. см приказ. будет понятно
        "sectionIV" : "Расчеты",  //не вносится в отчет. см приказ. будет понятно
        "sectionIV.I" : "Расчеты", //не вносится в отчет. см приказ. будет понятно
        "sectionVI" : "Проект",//не вносится в отчет. см приказ. будет понятно
        "stateAuthority" : "",
        "expertiseDate" : "",
        "expertiseNumber" : "",
        "expertiseObjectName" : "",
        "expertiseDuration" : ""
      }
    }
  };
}
